import React from "react";
import "./Skills.css";
import Card from "../../components/Card/Card";
import Animate from "../../components/Animate/Animate";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { IconContext } from "react-icons";
import "../../App.css";

function Skills() {
  return (
    <div className='skill-container'>
      <Animate>
        <div>
          <h1>Frontend</h1>
          <div className='skill-box'>
            <div className='skill-box-inside'>
              <Card title='React.js' completed={85} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Next.js' completed={85} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Vue.js' completed={80} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Tailwind' completed={80} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Scss' completed={85} />
            </div>
          </div>
        </div>
        <div>
          <h1>Cms & Headless Cms</h1>
          <div className='skill-box'>
            <div className='skill-box-inside'>
              <Card title='Sanity' completed={80} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Wordpress' completed={85} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Shopify' completed={70} />
            </div>
          </div>
        </div>
        <div>
          <h1>Backend</h1>
          <div className='skill-box'>
            <div className='skill-box-inside'>
              <Card title='Node.js' completed={75} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Laravel' completed={70} />
            </div>
          </div>
        </div>
        <div>
          <h1>Mobile Development</h1>
          <div className='skill-box'>
            <div className='skill-box-inside'>
              <Card title='React Native' completed={80} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Flutter' completed={70} />
            </div>
          </div>
        </div>
        <div>
          <h1>Languages</h1>
          <div className='skill-box'>
            <div className='skill-box-inside'>
              <Card title='C' completed={60} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Php' completed={60} />
            </div>
            <div className='skill-box-inside'>
              <Card title='JavaScript' completed={80} />
            </div>
            <div className='skill-box-inside'>
              <Card title='TypeScript' completed={65} />
            </div>
            <div className='skill-box-inside'>
              <Card title='Dart' completed={60} />
            </div>
          </div>
        </div>
      </Animate>
      <div
        style={{
          position: "absolute",
          right: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/portfolio' className='moveArrowLeft'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <p className='hover-text'>Portfolio</p>
              <IoIosArrowDown
                style={{
                  transform: "rotate(-90deg)",
                }}
              />
            </div>
          </IconContext.Provider>
        </Link>
      </div>
      <div
        style={{
          position: "absolute",
          left: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/contact' className='moveArrowRight'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <IoIosArrowDown style={{ transform: "rotate(90deg)" }} />
              <p className='hover-text'>Contact</p>
            </div>
          </IconContext.Provider>
        </Link>
      </div>
    </div>
  );
}

export default Skills;
